
import React from 'react';

const GamificationStyles: React.FC = () => {
  return (
    <style>
      {`
      .confetti-container {
        position: absolute;
        top: -100px;
        left: -100px;
        right: -100px;
        bottom: -100px;
        pointer-events: none;
      }
      
      .confetti-piece {
        position: absolute;
        top: 0;
        z-index: 10;
        transform-origin: center;
        animation: confetti-fall cubic-bezier(0.32, 0.36, 0.5, 1) forwards;
      }
      
      @keyframes confetti-fall {
        0% {
          transform: translateY(-10px) rotate(0deg);
          opacity: 1;
        }
        100% {
          transform: translateY(200px) rotate(720deg);
          opacity: 0;
        }
      }
      
      @keyframes progress-pulse {
        0% {
          opacity: 0.7;
        }
        50% {
          opacity: 1;
        }
        100% {
          opacity: 0.7;
        }
      }
      
      .progress-animate {
        animation: progress-pulse 1.5s ease-in-out infinite;
      }
      
      @keyframes medal-appear {
        0% {
          transform: scale(0.5);
          opacity: 0;
        }
        50% {
          transform: scale(1.1);
        }
        100% {
          transform: scale(1);
          opacity: 1;
        }
      }
      
      .medal-animate {
        animation: medal-appear 0.8s forwards;
      }
      `}
    </style>
  );
};

export default GamificationStyles;
